import { ref as u, computed as p, onMounted as I, onBeforeUnmount as O, onErrorCaptured as M, getCurrentInstance as h, onUnmounted as L } from "vue";
import { SeamlessConnection as P, initializeStore as V } from "@seamless/store";
/*! connection-aem-environment 2.8.0 */
const N = "OWC_AEM_ENV", _ = new class extends P {
  constructor() {
    super(N);
  }
  get initialState() {
    const e = window.aemNamespace?.environmentVariables || window.top?.aemNamespace?.environmentVariables, n = window.aemNamespace?.pageEnvironmentVariables || window.top?.aemNamespace?.pageEnvironmentVariables;
    return e && n ? { ...e, ...n } : {};
  }
  getReducer() {
    return () => this.initialState;
  }
  getPublicDispatchers() {
    return {};
  }
}(), T = async () => {
  const e = V();
  return await (async () => {
    if (!window.top?.aemNamespace && !window.aemNamespace) return new Promise((n) => {
      let a;
      Object.defineProperty(window.top, "aemNamespace", { get: () => a, async set(r) {
        a = r, n();
      } });
    });
  })(), await (async () => {
    if (!window.top?.aemNamespace?.environmentVariables && !window?.aemNamespace?.environmentVariables) return new Promise((n) => {
      let a;
      Object.defineProperty(window.top?.aemNamespace, "environmentVariables", { get: () => a, set(r) {
        a = r, n();
      } });
    });
  })(), await (async () => {
    if (!window.top?.aemNamespace?.pageEnvironmentVariables && !window?.aemNamespace?.pageEnvironmentVariables) return new Promise((n) => {
      let a;
      Object.defineProperty(window.top?.aemNamespace, "pageEnvironmentVariables", { get: () => a, set(r) {
        a = r, n();
      } });
    });
  })(), e.addConnection(_);
};
function D(e, n, a) {
  return !n || !a ? "" : `${n}${e[1]}${a}`;
}
const v = u(""), w = u(""), d = u(""), b = u(!1), $ = p(() => D`${d.value}_${w.value}`);
function C(e) {
  let n;
  return I(async () => {
    T(), n = await e.subscribe(
      N,
      (a) => {
        v.value = a.stage, w.value = a.country, d.value = a.language, b.value = !0;
      }
    ).unsubscribe;
  }), O(() => {
    n?.();
  }), {
    environment: v,
    country: w,
    language: d,
    marketId: $,
    aemLoaded: b
  };
}
function E(e) {
  throw Error(e);
}
var G = /* @__PURE__ */ ((e) => (e[e.COMPONENT = 1] = "COMPONENT", e[e.DATALOADING = 2] = "DATALOADING", e[e.IMAGE = 3] = "IMAGE", e[e.PLS = 4] = "PLS", e[e.FCIS = 5] = "FCIS", e))(G || {}), S = /* @__PURE__ */ ((e) => (e.CRITICAL = "CRITICAL", e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW", e))(S || {});
function y({ error: e, severity: n, component: a, message: r }, i) {
  switch (n) {
    case "CRITICAL":
    case "HIGH":
      i?.error("An error has been encountered, please find more information below"), i?.table({
        severity: n,
        category: a,
        message: r,
        cause: e?.cause?.message
      });
      break;
    case "MEDIUM":
    case "LOW":
    default:
      i?.log(`Error in component ${a} with severity ${n}: ${r}`, e);
      break;
  }
}
const R = (e) => {
  const n = u(/* @__PURE__ */ new Map());
  M((o, t, l) => {
    const c = t, s = c._.type.__name === "ErrorBoundary" ? h() ?? E("could not find vue instance") : c._, m = s.exposed?.severity ?? "CRITICAL", A = s.exposed?.category ?? 1, f = { error: o, severity: m, component: A, message: o.message };
    if (a(s, f), y(f, e.logger), e.onErrorCallback?.(), !e.allowPropagation) return !1;
  }), I(() => {
    r();
  }), L(() => {
    r();
  });
  function a(o, { error: t, severity: l, component: c }) {
    const s = o.type.name ?? o.type.__name ?? E("a component catching errors must have a name");
    if (n.value.has(s)) {
      const m = n.value.get(s);
      if (!m) return;
      n.value.set(s, [
        ...m,
        { error: t, severity: l, component: c, message: t?.message ?? "" }
      ]);
    } else
      n.value.set(s, [
        { error: t, severity: l, component: c, message: t?.message ?? "" }
      ]);
  }
  function r() {
    n.value.clear();
  }
  const i = p(() => !!n.value.size), g = p(() => Array.from(n.value.values()).reduce((o, t) => o + t.length, 0));
  return { componentsWithErrors: n, hasErrors: i, errorCount: g };
};
export {
  G as C,
  S,
  b as a,
  y as b,
  w as c,
  R as d,
  v as e,
  d as l,
  $ as m,
  E as r,
  C as u
};
//# sourceMappingURL=useErrorCapturer-LYriEvzM.js.map
